import React from 'react';

import { P2 } from '@repo/ui-kit/components/core/Typography';

import type { CreateFirstUseCase } from '../types';

import { CardImage, CardWrapper } from './styles';

interface CreateFirstCardProps {
  item: CreateFirstUseCase;
  onSelect: (item: CreateFirstUseCase) => void;
  isDisabled?: boolean;
}

export const CreateFirstCard: React.FC<CreateFirstCardProps> = ({
  item,
  onSelect,
  isDisabled = false,
}) => {
  const handleClick = (): void => {
    if (isDisabled) {
      return;
    }
    onSelect(item);
  };

  return (
    <CardWrapper isDisabled={isDisabled} onClick={handleClick}>
      <CardImage alt={item.name} src={item.imagePath} />
      <P2>{item.name}</P2>
    </CardWrapper>
  );
};
